import Svg, { SvgProps, Path } from 'react-native-svg'

export function CompetitiveRates({ ...props }: SvgProps) {
  return (
    <Svg width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}>
      <Path fill="#00DFC9" d="m5.333 12.666 4 3.333L16 6.666l6 4 4 .667 1.333 14.666h-22V12.666Z" />
      <Path
        fill="#223843"
        d="m18.2 5.767 4.467 3.567h2.666c.734 0 1.361.261 1.884.784.522.522.783 1.15.783 1.883v14.667H4V12c0-.556.244-.956.733-1.2.49-.245.956-.2 1.4.133l3.2 2.4 5.034-7.033a2.591 2.591 0 0 1 1.8-1.1c.755-.111 1.433.078 2.033.566Zm-11.533 8.9v4.8l4 3.2L16 15.335l9.333 7.267V12h-3.6l-5.2-4.167-6.6 9.267-3.266-2.433Z"
      />
    </Svg>
  )
}
